import {
  deprecatedQualificationWarning,
  Survey,
  TemplateQualification,
} from '@ps/survey-utils';

/**
 * A template qualification the created survey no longer carries was updated or
 * deprecated since the template was saved — one warning each, as legacy does.
 */
export function templateDeprecatedQualificationWarnings(
  templateQualifications: readonly TemplateQualification[],
  survey: Survey,
): readonly string[] {
  // A response without qualifications says nothing about what was dropped.
  if (!survey.qualifications) {
    return [];
  }
  const surveyCodes = new Set(
    survey.qualifications.map(
      (qualification) => qualification.qualificationCode,
    ),
  );
  return templateQualifications
    .filter(
      (qualification) => !surveyCodes.has(qualification.qualificationCode),
    )
    .map((qualification) =>
      deprecatedQualificationWarning(qualification.qualificationName),
    );
}
